import { createAction, props } from '@ngrx/store';

import { ListingsEntity } from './models/listings-entity';

export const init = createAction('[Listings] Init / Get Listings');

export const loadListingsSuccess = createAction(
  '[Listings] Load Listings Success',
  props<{ listings: ListingsEntity[] }>()
);

export const loadListingsFailure = createAction(
  '[Listings] Load Listings Failure',
  props<{ error: any }>()
);

export const addListing = createAction(
  '[Listings] Add Listing',
  props<{ listing: ListingsEntity }>()
);

export const addListingSuccess = createAction(
  '[Listings] Add Listing Success',
  props<{ listings: ListingsEntity }>()
);

export const addListingFailure = createAction(
  '[Listings] Add Listing Failure',
  props<{ error: any }>()
);
